import React from "react";
import '../Styles/Choose.css';
import { Link } from 'react-router-dom';
import { Fade } from "react-awesome-reveal";
import { Zoom } from 'react-awesome-reveal';
import CountUp from 'react-countup';
import { Helmet } from "react-helmet-async";
import VisibilitySensor from 'react-visibility-sensor';
import 'bootstrap/dist/css/bootstrap.min.css';

const stats = [
  { value: 99, suffix: '%', label: 'Job Satisfaction Ratio', bg: '#ffede7', color: 'text-danger' },
  { value: 5, suffix: '+', label: 'Years of Experience', bg: '#f2ecff', color: 'text-primary' },
  { value: 3500, suffix: '+', label: 'Successful Projects', bg: '#eaf7e8', color: 'text-success' },
  { value: 25, suffix: '+', label: 'Experts', bg: '#e6ebff', color: 'text-primary' },
  { value: 20, suffix: '+', label: 'Global Clients', bg: '#e0f9f4', color: 'text-info' },
];

const reasons = [
  {
    icon: "fas fa-users", // FontAwesome icon class
    color: "#f5b300",
    title: "Expert Green Teams",
    description:
      "Our skilled and trained professionals bring deep expertise in energy efficiency, solar solutions, and sustainable practices to deliver the best results.",
  },
  {
    icon: "fas fa-hand-holding-usd",
    color: "#e63946",
    title: "Cost-Effective Solutions",
    description:
      "We provide affordable, energy-saving solutions designed to lower utility costs while ensuring long-term value and sustainability.",
  },
  {
    icon: "fas fa-clipboard-check",
    color: "#6f42c1",
    title: "Quality & Reliability",
    description:
      "We are committed to delivering top-notch services with high-quality standards, ensuring reliable and eco-friendly solutions every time.",
  },
  {
    icon: "fas fa-headset",
    color: "#2ca58d",
    title: "Quick Support",
    description:
      "Our dedicated support team is always available to provide fast and efficient assistance for your energy and environmental needs.",
  },
  {
    icon: "fas fa-award",
    color: "#007bff",
    title: "Certified Excellence",
    description:
      "Recognized for innovation and sustainability, Paramount Green Services is proud to uphold industry standards and certifications in green energy.",
  },
  {
    icon: "fas fa-star",
    color: "#fd7e14",
    title: "Trusted by Clients",
    description:
      "Our clients trust us for delivering impactful and sustainable energy solutions that truly make a difference in business and communities.",
  },
];


const teamData = [
  { label: 'Backend Developers', percent: 50, color: 'purple' },
  { label: 'Front End Developers', percent: 25, color: 'blue' },
  { label: 'Sales & Management Team', percent: 10, color: 'indigo' },
  { label: 'Designer Team', percent: 5, color: 'orange' },
  { label: 'Project Managers', percent: 5, color: 'teal' },
  { label: 'QA Testers', percent: 5, color: 'pink' },
];

const ChooseUs = () => {
  return (
    <>
      <Helmet>
        <title>Why Choose Us || Paramount Green Services</title>
        <meta name="description" content="Free heating, insulation, and solar panel grants across the UK. Transform your home’s energy efficiency today." />
      </Helmet>

      {/* Header Section */}
      <section className="about-header text-center mb-5">
        <div className="header-overlay" style={{ marginTop: "120px" }}>
          <h1>Why Choose Us</h1>
          {/* <p>Home &gt; About Us</p> */}
        </div>
      </section>
      <div className="container my-5">
        <div className="row">
          {/* Left Text Section */}
          <div className="col-md-6">
            <h2 className="fw-bold mb-3">Why Choose <span className="text-success">Us</span></h2>
            <p>
              At <strong className="text-success"><Link to="/" className="text-success text-decoration-none">Paramount Green Services</Link></strong>, we specialize in delivering
              energy-efficient solutions that help homeowners, landlords, and tenants
              save money while reducing carbon footprints.
              With years of expertise in EPC upgrades and sustainable energy systems,
              we are committed to making every property greener and more efficient.
            </p>
            <strong>Our value-added benefits include:</strong>
            <div className="row mt-3">
              <div className="col-6">
                <ul className="list-unstyled">
                  <li>• Expertise in Green Technologies</li>
                  <li>• EPC & Regulation Compliance</li>
                  <li>• Lower Energy Bills</li>
                  <li>• Property Value Enhancement</li>
                </ul>
              </div>
              <div className="col-6">
                <ul className="list-unstyled">
                  <li>• Nationwide Coverage</li>
                  <li>• Fast & Reliable Installation</li>
                  <li>• Government-Backed Schemes</li>
                  <li>• Ongoing Support & Maintenance</li>
                </ul>
              </div>
            </div>
            <button className="btn btn-success mt-4 mb-4">
              <Link to="/Contactus/" className="text-white text-decoration-none">Let’s Connect ➔ </Link>
            </button>
          </div>

          {/* Right Stats Section */}
          <div className="col-md-6">
            <div className="d-flex flex-wrap justify-content-between">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="p-4 mb-3 text-center rounded"
                  style={{ backgroundColor: stat.bg, flexBasis: "48%" }}
                >
                  <h2 className={`fw-bold ${stat.color}`}>
                    <CountUp start={0} end={stat.value} duration={2} suffix={stat.suffix}>
                      {({ countUpRef, start }) => (
                        <VisibilitySensor onChange={start} delayedCall>
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                  </h2>
                  <p className="fw-semibold">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-5" style={{ marginBottom: "80px" }}>
        <h6 className="text-success fade-in ">DRIVING SUCCESS WITH EXPERTISE</h6>
        <h2 className="fw-bold mb-5 fade-in delay-1">Team Stats</h2>
      </div>

      <div className="team-stats-section container text-center py-5 d-none d-lg-block">


        <div className="team-stats-circle-container fade-in delay-2">
          <div className="center-circle">
            <div className="main-circle">
              <h3 className="mb-0">25+</h3>
              <p>Experts</p>
            </div>
          </div>

          {/* Connecting lines */}
          <div className="connecting-line line-0" />
          <div className="connecting-line line-1" />
          <div className="connecting-line line-2" />
          <div className="connecting-line line-3" />
          <div className="connecting-line line-4" />
          <div className="connecting-line line-5" />

          {teamData.map((item, index) => (
            <div className={`stat-circle position-${index}`} key={index}>
              <div
                className={`circle-progress ${item.color}`}
                style={{ '--value': item.percent }}
              >
                <div className="circle-inner">
                  <h4>
                    <CountUp end={item.percent} duration={3.5} delay={0.5} />%
                  </h4>
                  <p>{item.label}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <section className="choose-reasons-section text-center py-5">
        <div className="container">
          <p className="text-success fw-semibold mb-2" style={{ letterSpacing: '1px' }}>
            — LET’S GROW TOGETHER —
          </p>
          <h2 className="fw-bold mb-3" style={{ color: '#1b1c57', fontSize: '2rem' }}>
            <Fade>Few Reasons to Choose us</Fade>
          </h2>
          <p className="text-muted mb-4" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Our professional teams enable our clients to stay ahead in the game by taking advantage of innovative technologies, tools, and practices. We craft customized solutions precisely designed for your business and operational needs. Some more reasons:
          </p>
          {/* <button className="btn btn-success px-4 py-2 rounded-pill fw-semibold">
                        View Testimonials
                    </button> */}
        </div>
      </section>
            <Zoom>
                    <section className="py-5 reasons-grid-section">
        <div className="container">
          <div className="row g-4">
            {reasons.map((reason, index) => (
              <div key={index} className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm p-4">
                  <div className="icon mb-3" style={{ color: reason.color, fontSize: '2rem' }}>
                    <i className={reason.icon}></i>
                  </div>
                  <h5 className="fw-bold text-dark">{reason.title}</h5>
                  <p className="text-muted">{reason.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
            </Zoom>

        {/* CTA / Footer Hero */}
        <section className="py-5 text-center text-white">
          <div className="container">
            <h2 className="fw-bold mb-3 text-success">Check Our Team</h2>
            <p className="mb-4 text-black">
              Find out what grants you qualify for and start saving on your energy bills immediately.
            </p>

            <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
              <Link to="/Ourteam/" className="btn btn-lg eco4-btn-primary">View Our Team</Link>
            </div>
          </div>
        </section>
    </>

  );
};

export default ChooseUs;
